import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import AuthShell from "@/components/AuthShell";
import { api, errorMessage } from "@/lib/api";

export default function ResetPasswordPage() {
  const { token } = useParams();
  const nav = useNavigate();
  const [form, setForm] = useState({ pw: "", confirm: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (form.pw !== form.confirm) { setError("Passwords do not match."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: form.pw });
      nav("/login", { replace: true, state: { resetOk: true } });
    } catch (err) {
      setError(errorMessage(err));
    } finally { setLoading(false); }
  };

  return (
    <AuthShell
      title="Set a new password."
      subtitle="Reset password"
      footer={<div>Need a new link? <Link to="/forgot-password" className="link-underline font-semibold text-foreground">Request reset</Link></div>}
    >
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="block text-[12px] font-semibold uppercase tracking-wider text-muted-foreground mb-1.5">New password</label>
          <input data-testid="reset-pw-input" required type="password" minLength={6} value={form.pw} onChange={(e) => setForm({ ...form, pw: e.target.value })}
            className="w-full h-11 px-3 border border-border bg-white focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary" />
        </div>
        <div>
          <label className="block text-[12px] font-semibold uppercase tracking-wider text-muted-foreground mb-1.5">Confirm password</label>
          <input data-testid="reset-confirm-input" required type="password" minLength={6} value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })}
            className="w-full h-11 px-3 border border-border bg-white focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary" />
        </div>
        {error && <div className="text-[13px] text-destructive">{error}</div>}
        <button data-testid="reset-submit-button" disabled={loading} type="submit"
          className="w-full h-11 bg-primary text-primary-foreground font-semibold text-[14px] hover:bg-[#001d6b] disabled:opacity-60">
          {loading ? "Updating..." : "Update password"}
        </button>
      </form>
    </AuthShell>
  );
}
